import { create } from "zustand";

type ImageFile = {
  key: string;
  url: string;
  ETag: string;
};

type CoverImage = ImageFile & {
  coordinates?: {
    width: number;
    height: number;
    x: number;
    y: number;
  };
};

export type User = {
  _id?: string;
  profileImage?: ImageFile;
  coverImage?: CoverImage;
  password?: string;
  source?: string;
  phone?: string;
  account_type?: string;
  active?: boolean;
  status?: string;
  country_name?: string;
  username?: string;
  email?: string;
  address?: string;
  postal_code?: string;
  first_name?: string;
  last_name?: string;
  company_name?: string;
  country_iso_code?: string;
  city?: string;
  timezone?: string;
  dob?: string;
};


type UserStore = {
  user: User | null;
  isLoading: boolean;
  signupToken?: string;
  setUser: (user: User) => void;
  setIsLoading: (loading: boolean) => void;
  setSignupToken: (token: string) => void;
  clearUser: () => void;
};

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  isLoading: true,
  signupToken: undefined,
  setUser: (user) => set((state) => ({ ...state, user })),
  setIsLoading: (loading) => set((state) => ({ ...state, isLoading: loading })),
  setSignupToken: (token) => set((state) => ({ ...state, signupToken: token })),
  clearUser: () => set({ user: null, signupToken: undefined }),
}));
